import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import landing_background1 from '../../img/other/landing_background1.jpg'
import landing_background2 from '../../img/other/landing_background2.jpg'
import landing_background3 from '../../img/other/landing_background3.jpg'
import { Typography, Paper } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEuroSign, faUserMd, faEnvelope, faPhone, faHeart, faMapMarker, faBell, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import AppBarPortal from '../shared/components/AppBarPortal';
import AppFooterPortal from '../shared/components/AppFooterPortal';
import AppBarLandingMobile from '../shared/components/AppBarLandingMobile';
import DrawerLandingMobile from '../shared/components/DrawerLandingMobile';

import corteingles from '../../img/assets_landing/corteingles.png';
import zara from '../../img/assets_landing/zara.png';
import carrefour from '../../img/assets_landing/carrefour.png';
import amazon from '../../img/assets_landing/amazon.png';


const gratificationSection = (classes) => {
  return (
    <Grid container>
    <Grid item xs={12} className={classes.gratification}>
      <div className={classes.gratificationContainer}>
        <div className={classes.container1280}>
          <Typography variant="display1" style={{color: '#000'}} paragraph>
            ¡Canjea tus puntos por las tarjetas regalo del catálogo!
          </Typography>
          <Typography variant="subheading" paragraph>
            Los estudios con voluntarios serán gratificados con puntos.
          </Typography>

          <ul>
            <li>
              <Typography variant="body1" paragraph>
                Cada estudio tiene una gratificación determinada. Cuando te invitemos a participar en un estudio 
                se te indicarán los puntos que puedes conseguir con tu participación.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" paragraph>
                Los puntos se irán acumulando en tu cuenta. Cuando lo desees podrás canjear los puntos por las 
                tarjetas regalo que selecciones del catálogo.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" paragraph>
                Obtén tarjetas desde el primer estudio que realices.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" paragraph>
                Cada vez que la tarjeta canjeada tenga un valor superior a <strong>500 puntos</strong> (Cosmos) equivalente a 
                <strong> 50&euro;</strong>, recibirás <strong>25 puntos de regalo</strong>.
              </Typography>
            </li>
          </ul>

          <div className={classes.logoContainer}>
            <img src={corteingles} className={classes.logo} />
            <img src={zara} className={classes.logo} />
            <img src={carrefour} className={classes.logo} />
            <img src={amazon} className={classes.logo} />
          </div>

        </div>
      </div>
    </Grid>
  </Grid>
  )
}

const gratificationSectionMobile = (classes) => {
  return (
    <React.Fragment>

      <Grid container>
      <Grid item xs={12} className={classes.gratification}>

        <Typography variant="display1" paragraph style={{color: '#000', marginTop: 30}}>
          ¡Canjea tus puntos por las tarjetas regalo del catálogo!
        </Typography>
        <Typography variant="subheading" paragraph style={{marginBottom: 30}}>
          Los estudios con voluntarios serán gratificados con puntos.
        </Typography>

        <div className={classes.gratificationContainer} style={{margin: 0}}>
          <div className={classes.container1280}>

            <ul style={{margin: 0, padding: 0}}>
              <li>
                <Typography variant="body1" paragraph>
                  Cada estudio tiene una gratificación determinada. Cuando te invitemos a participar en un estudio 
                  se te indicarán los puntos que puedes conseguir con tu participación.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" paragraph>
                  Los puntos se irán acumulando en tu cuenta. Cuando lo desees podrás canjear los puntos por las 
                  tarjetas regalo que selecciones del catálogo.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" paragraph>
                  Obtén tarjetas desde el primer estudio que realices.
                </Typography>
              </li>
              <li>
                <Typography variant="body1" paragraph>
                  Cada vez que la tarjeta canjeada tenga un valor superior a <strong>500 puntos</strong> (Cosmos) equivalente a 
                  <strong> 50&euro;</strong>, recibirás <strong>25 puntos cosmos de regalo</strong>.
                </Typography>
              </li>
            </ul>

          </div>
        </div>
      </Grid>
    </Grid>

  </React.Fragment>
  )
}

const styles = theme => ({
  container: {
    display: 'flex', 
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  section1: {
    background: 'url('+landing_background3+') no-repeat center center',
    backgroundPositionY: '8%',
    borderBottom: '3px solid #fff',
    height: 'calc(48% - 3px)',
    minHeight: 450,
    backgroundSize: '100%',
    '@media(max-width: 1281px)': {
      height: 'auto !important',
      minHeight: 'auto'
    }
  },
  section2: {
    background: 'url('+landing_background2+') no-repeat center center',
    backgroundPositionY: 'center',
    height: '48%',
    minHeight: 450,
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      minHeight: 'auto'
    }
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    position: 'absolute',
    bottom: 0,
    borderRadius: 0,
    minHeight: '90%',
    marginLeft: 10,
    [theme.breakpoints.down('md')]: {
      position: 'initial',
      paddingTop: theme.spacing.unit * 5,
      paddingBottom: theme.spacing.unit * 3,
      marginLeft: 0,
    }
  },
  iconContainer: {
    //border: '1px solid #42b8d4',
    border: '1px solid #000',
    borderRadius: '50%',
    padding: 0,
    textAlign: 'center',
    width: 60,
    height: 60,
    display: 'flex',
    verticalAlign: 'middle',
    [theme.breakpoints.between("sm", "md")]: {
      width: 48,
      height: 48,
    },
    alignItems: 'center',
    justifyContent: 'center'
  },
  number:{
    fontWeight: 500,
    color: '#42b8d4',
    fontSize: '1.2rem'
  },
  buttonIndigo: theme.custom.button.indigo,
  buttonBlue: theme.custom.button.blue,
  buttonOrange: {
    textTransform: 'inherit',
    background: 'rgba(245, 166, 35, 1)',
    color: 'rgba(255, 255, 255, 1)',
    border: '1px solid rgba(245, 166, 35, 1)',
    '&:hover': {
      background: 'transparent',
      color: 'rgba(199, 104, 23, 1)',
      border: '1px solid rgba(199, 104, 23, 1)',
    }
  },
  container1280: {
    height: '100%', 
    padding: 25, 
    maxWidth: 1280, 
    margin: '0 auto',
    [theme.breakpoints.between('md', 'lg')]: {
      maxWidth: 1100,
    },
  },
  containerMobile: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    }
  },
  "@global": {
    html: {
      [theme.breakpoints.between("sm", "md")]: {
        fontSize: 13
      }
    }
  },
  heading: {
    fontSize: '1rem',
    fontWeight: 500
  },
  rightContent: {
    fontSize: '1.1rem',
    color: '#9E9C9F',
    [theme.breakpoints.between('md', 'lg')]: {
      fontSize: '1rem',
    },
  },
  textBlock: {
    padding: '5px',
    color: '#959595'
  },
  textBlock1: {
    padding: '5px',
    color: '#fff'
  },
  gratificationContainer: {
    padding: 15,
    background: 'rgba(255,255,255, 0.85)',
    margin: 15,
  },
  logoContainer: {
    padding: 0,
    marginTop: 30,
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      padding: 0
    }
  },
  logo: {
    lineHeight: 15,
    verticalAlign: 'middle',
    marginRight: 60,
    maxHeight: 32,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginRight: 'initial',
      maxHeight: 50,
    }
  },
  logoItem: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '50%',
      textAlign: 'center',
      float: 'left',
      padding: 35
    }
  }
})


class HowItWorks extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      gratificationIsOpen: false
    }

    this.toggleGratification = this.toggleGratification.bind(this);
  }

  componentDidMount() {
    document.body.classList.add("how-it-works");
    document.title = "¿Cómo participar?"
  }

  componentWillUnmount() {
    document.body.classList.remove("how-it-works");
    document.title = "Cosmocare Portal"
  }

  toggleGratification() {
    this.setState({
      gratificationIsOpen: !this.state.gratificationIsOpen
    })
  }

  render() {

    const { classes } = this.props;

    return (
      <React.Fragment>
        {!isMobileOnly && <AppBarPortal />}
        {!isMobileOnly && <AppFooterPortal />}

      <div className={classes.container}>
        <Grid container spacing={0}>
          <Grid 
            item xs={12} 
            className={classes.section1} 
            style={{
              height: this.state.gratificationIsOpen ? 'auto' : 'calc(48% - 3px)',
              backgroundPositionY: this.state.gratificationIsOpen ? '39%' : '8%'
            }}
          >

            <Grid 
              container 
              className={classes.container1280}
              style={{
                height: this.state.gratificationIsOpen ? 'auto' : '100%'
              }}
            >
              <Grid item xs={12} md={9} style={{alignSelf: 'center'}}>
                <Typography paragraph variant="display1" style={{color: '#000'}}>
                  ¿Te gustan los productos cosméticos y quieres ganar dinero extra a fin de mes?
                </Typography>
                <Typography variant="subheading" style={{marginTop: 35, marginBottom: 35}}>
                  Regístrate ahora como <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=v' style={{marginLeft: 15}}>Voluntario</Button>
                </Typography>
                


                <Grid container spacing={8} style={{marginTop: 25}}>
                  <Grid item xs={12} md={4}>

                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faEuroSign} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="div" className={classes.heading} paragraph>Gratificación</Typography>
                        <Typography paragraph>Una forma fácil y práctica de obtener ingresos a fin de mes.</Typography>
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faUserMd} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="div" className={classes.heading} paragraph>Equipo profesional</Typography>
                        <Typography paragraph>Estudios realizados con total seguridad gracias a nuestros expertos científicos.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faBell} mask={['far', 'circle']} size="2x" />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="div" className={classes.heading} paragraph>Avisos</Typography>
                        <Typography paragraph>Recibe toda la información en tu móvil y lleva el control desde tu casa.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                </Grid>

                <Grid container spacing={8} style={{marginTop: 25}}>
                  <Grid item xs={12} md={4}>
                    <Button 
                      variant="contained" 
                      className={classes.buttonOrange} 
                      style={{marginLeft: 0}}
                      onClick={this.toggleGratification}
                    >
                      Gratificación: ¿Cómo funciona?
                    </Button>
                  </Grid>
                </Grid>



              </Grid>
              
              <Grid item xs={12} md={3}>
                <div style={{position: 'relative', height: '80%'}}>
                <Paper className={classes.paper}>

                  <Grid container>
                    <Grid item xs={12} align="center">
                      <Typography paragraph variant='headline'>¿Cómo participar?</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>1.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent}>Rellena el formulario de inscripción</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>2.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent}>Apúntate a los estudios</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>3.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent}>Ven a CosmoCare y prueba los productos cosméticos</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>4.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent} paragraph>Recibe una gratificación económica</Typography>
                    </Grid>
                  </Grid>

                </Paper>
                </div>
              </Grid>
            </Grid>

            {this.state.gratificationIsOpen && gratificationSection(classes)}

          </Grid>


          <Grid item xs={12} className={classes.section2}>

            <Grid container className={classes.container1280}>
              <Grid item xs={12} md={9} style={{alignSelf: 'center'}}>
                <Typography paragraph variant="display1" style={{color: '#000'}}>
                  ¿Eres mayor de edad y quieres probar productos cosméticos de calidad sin desplazarte de tu casa y de forma gratuita?
                </Typography>
                <Typography variant="subheading" style={{marginTop: 35, marginBottom: 35}}>
                  Regístrate ahora como <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=c' style={{marginLeft: 15}}>Consumidor</Button>
                </Typography>
                


                <Grid container spacing={8} style={{marginTop: 25}}>
                  <Grid item xs={12} md={4}>

                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faCheckCircle} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="div" className={classes.heading} paragraph>Productos de calidad</Typography>
                        <Typography paragraph>Todos los productos han sido previamente evaluados y aprobados por nuestros expertos.</Typography>
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faHeart} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="div" className={classes.heading} paragraph>Comparte tu opinión</Typography>
                        <Typography paragraph>Tu opinión es importante. Prueba productos cosméticos y envíanos tu opinión online.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={3}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faBell} mask={['far', 'circle']} size="2x" />
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        <Typography component="div" className={classes.heading} paragraph>Avisos</Typography>
                        <Typography paragraph>Recibe toda la información en tu móvil y lleva el control desde tu casa.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                </Grid>



              </Grid>
              <Grid item xs={12} md={3}>
                <div style={{position: 'relative', height: '80%'}}>
                <Paper className={classes.paper}>

                  <Grid container>
                    <Grid item xs={12} align="center">
                      <Typography paragraph variant='headline'>¿Cómo participar?</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>1.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent}>Rellena el formulario de inscripción</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>2.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent}>Apúntate a los estudios</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>3.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography className={classes.rightContent}>Recibe los productos en tu casa y pruébalos</Typography>
                    </Grid>
                    <Grid item xs={1}>
                      <Typography className={classes.number}>4.</Typography>
                    </Grid>
                    <Grid item xs={11}>
                      <Typography paragraph className={classes.rightContent}>Danos tu opinión sobre el producto mediante el cuestionario online</Typography>
                    </Grid>
                  </Grid>

                </Paper>
                </div>
              </Grid>
            </Grid>

          </Grid>
        </Grid>
      </div>
      
      {isMobileOnly && <AppBarLandingMobile />}
      {isMobileOnly && <DrawerLandingMobile />}
      <div className={classes.containerMobile}>
        
        <Grid container>
          <Grid item xs={12}>
            <div style={{ 
              padding: 20, 
              textAlign: 'center', 
              background: 'url('+landing_background3+') center center no-repeat',
              backgroundPositionY: this.state.gratificationIsOpen ? '43%' : 'center',
              backgroundPositionX: this.state.gratificationIsOpen ? '55%' : 'center'
              }}>
              <Typography paragraph variant="display1" style={{color: '#000', fontSize: '1.6rem'}}>
                ¿Te gustan los productos cosméticos y quieres ganar dinero extra a fin de mes?
              </Typography>
              <Typography paragraph variant="subheading">
                Regístrate ahora como
              </Typography>
              <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=v'>Voluntario</Button>

              <Grid container spacing={8} style={{marginTop: 25, textAlign: 'left'}}>
                  <Grid item xs={12} md={4}>

                    <Grid container spacing={0}>
                      <Grid item xs={0} sm={3}></Grid>
                      <Grid item xs={3} sm={1}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faEuroSign} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9} sm={8}>
                        <Typography component="div" className={classes.heading}>Gratificación</Typography>
                        <Typography paragraph>Una forma fácil y práctica de obtener ingresos a fin de mes.</Typography>
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={0} sm={3}></Grid>
                      <Grid item xs={3} sm={1}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faUserMd} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9} sm={8}>
                        <Typography component="div" className={classes.heading}>Equipo profesional</Typography>
                        <Typography paragraph>Estudios realizados con total seguridad gracias a nuestros expertos científicos.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={0} sm={3}></Grid>
                      <Grid item xs={3} sm={1}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faBell} mask={['far', 'circle']} size="2x" />
                        </div>
                      </Grid>
                      <Grid item xs={9} sm={8}>
                        <Typography component="div" className={classes.heading}>Avisos</Typography>
                        <Typography paragraph>Recibe toda la información en tu móvil y lleva el control desde tu casa.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                  <Grid item xs={12} textAlign="center">
                    <Button 
                        variant="contained" 
                        className={classes.buttonOrange} 
                        style={{marginLeft: 0, marginTop: 30}}
                        onClick={this.toggleGratification}
                        fullWidth
                      >
                        Gratificación: ¿Cómo funciona?
                    </Button>
                  </Grid>
                  {this.state.gratificationIsOpen &&
                    <Grid item xs={12}>
                      {gratificationSectionMobile(classes)}
                    </Grid>
                  }
                </Grid>



            </div>
            {this.state.gratificationIsOpen &&
              <div className={classes.logoContainer} style={{background: '#F6F7F9'}}>

                <div className={classes.logoItem}>
                  <img src={corteingles} className={classes.logo} />
                </div>

                <div className={classes.logoItem}>
                  <img src={zara} className={classes.logo} />
                </div>

                <div style={{clear: 'both'}}></div>

                <div className={classes.logoItem}>
                  <img src={carrefour} className={classes.logo} />
                </div>

                <div className={classes.logoItem}>
                  <img src={amazon} className={classes.logo} />
                </div>

                <div style={{clear: 'both'}}></div>

              </div>
            }
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper} style={{padding: 30}}>

              <Grid container spacing={16}>
                <Grid item xs={12} align="center">
                  <Typography paragraph variant='headline'>¿Cómo participar?</Typography>
                </Grid>
                <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                  <Typography className={classes.number}>1.</Typography>
                </Grid>
                <Grid item xs={11} sm={8}>
                  <Typography className={classes.rightContent}>Rellena el formulario de inscripción</Typography>
                </Grid>
                <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                  <Typography className={classes.number}>2.</Typography>
                </Grid>
                <Grid item xs={11} sm={8}>
                  <Typography className={classes.rightContent}>Apúntate a los estudios</Typography>
                </Grid>
                <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                  <Typography className={classes.number}>3.</Typography>
                </Grid>
                <Grid item xs={11} sm={8}>
                  <Typography className={classes.rightContent}>Ven a CosmoCare y prueba los productos cosméticos</Typography>
                </Grid>
                <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                  <Typography className={classes.number}>4.</Typography>
                </Grid>
                <Grid item xs={11} sm={8}>
                  <Typography className={classes.rightContent}>Recibe una gratificación económica</Typography>
                </Grid>
                <Grid item xs={12} align="center">
                  <Button 
                    variant="outline" 
                    className={classes.buttonBlue} 
                    component={Link} 
                    to='/register?type=v'
                    style={{margin: 25}}
                  >
                    Participa Ahora
                  </Button>
                </Grid>
              </Grid>
              

            </Paper>
          </Grid>
          <Grid item xs={12}>
            <div style={{ padding: 20, textAlign: 'center', background: 'url('+landing_background1+') repeat-y' }}>
              <Typography paragraph variant="display1" style={{color: '#000', fontSize: '1.6rem'}}>
                ¿Eres mayor de edad y quieres probar productos cosméticos de calidad sin desplazarte de tu casa y de forma gratuita?
              </Typography>
              <Typography paragraph variant="subheading">
                Regístrate ahora como
              </Typography>
              <Button variant="contained" className={classes.buttonIndigo} component={Link} to='/register?type=c'>Consumidor</Button>

                <Grid container spacing={8} style={{marginTop: 25, textAlign: 'left'}}>
                  <Grid item xs={12} md={4}>

                    <Grid container spacing={0}>
                      <Grid item xs={0} sm={3}></Grid>
                      <Grid item xs={3} sm={1}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faCheckCircle} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9} sm={8}>
                        <Typography component="div" className={classes.heading}>Productos de calidad</Typography>
                        <Typography paragraph>Todos los productos han sido previamente evaluados y aprobados por nuestros expertos.</Typography>
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={0} sm={3}></Grid>
                      <Grid item xs={3} sm={1}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faHeart} mask={['far', 'circle']} size="2x"  />
                        </div>
                      </Grid>
                      <Grid item xs={9} sm={8}>
                        <Typography component="div" className={classes.heading}>Comparte tu opinión</Typography>
                        <Typography paragraph>Tu opinión es importante. Prueba productos cosméticos y envíanos tu opinión online.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                  <Grid item xs={12} md={4}>
                  
                    <Grid container spacing={0}>
                      <Grid item xs={0} sm={3}></Grid>
                      <Grid item xs={3} sm={1}>
                        <div className={classes.iconContainer}>
                          <FontAwesomeIcon icon={faBell} mask={['far', 'circle']} size="2x" />
                        </div>
                      </Grid>
                      <Grid item xs={9} sm={8}>
                        <Typography component="div" className={classes.heading}>Avisos</Typography>
                        <Typography paragraph>Recibe toda la información en tu móvil y lleva el control desde tu casa.</Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                </Grid>

            </div>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper} style={{padding: 30}}>

                  <Grid container spacing={16}>
                    <Grid item xs={12} align="center">
                      <Typography paragraph variant='headline'>¿Cómo participar?</Typography>
                    </Grid>
                    <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                      <Typography className={classes.number}>1.</Typography>
                    </Grid>
                    <Grid item xs={11} sm={8}>
                      <Typography className={classes.rightContent}>Rellena el formulario de inscripción</Typography>
                    </Grid>
                    <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                      <Typography className={classes.number}>2.</Typography>
                    </Grid>
                    <Grid item xs={11} sm={8}>
                      <Typography className={classes.rightContent}>Apúntate a los estudios</Typography>
                    </Grid>
                    <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                      <Typography className={classes.number}>3.</Typography>
                    </Grid>
                    <Grid item xs={11} sm={8}>
                      <Typography className={classes.rightContent}>Recibe los productos en tu casa y pruébalos</Typography>
                    </Grid>
                    <Grid item xs={1} sm={4} align={isTablet ? 'right' : 'left'}>
                      <Typography className={classes.number}>4.</Typography>
                    </Grid>
                    <Grid item xs={11} sm={8}>
                      <Typography className={classes.rightContent}>Danos tu opinión sobre el producto mediante el cuestionario online</Typography>
                    </Grid>
                    <Grid item xs={12} align="center">
                      <Button 
                        variant="outline" 
                        className={classes.buttonBlue} 
                        component={Link} 
                        to='/register?type=c'
                        style={{margin: 25}}
                      >
                        Participa Ahora
                      </Button>
                    </Grid>
                  </Grid>

            </Paper>
          </Grid>
          <Grid item xs={12} align="center" style={{backgroundColor: '#F6F7F9', color: '#959595'}}>
            <div style={{padding: 25}}>
            
              <Typography className={classes.textBlock} component="a" href="https://www.google.com/maps/dir/?api=1&destination=41.384733,2.160988" target="_blank">
                <FontAwesomeIcon icon={faMapMarker} size="1x" style={{marginRight: 5}} /> C/ Diputación, 180, 6º oficinas B y C 08011 Barcelona
              </Typography>

              <Typography className={classes.textBlock} component="a" href="tel:+34937376400">
                <FontAwesomeIcon icon={faPhone} size="1x" style={{marginRight: 5}} /> 937 37 64 00
              </Typography>

              <Typography className={classes.textBlock} component="a" href="mailto:contact@cosmocare.eu">
                <FontAwesomeIcon icon={faEnvelope} size="1x" style={{marginRight: 5}} /> contact@cosmocare.eu
              </Typography>
            
            </div>
          </Grid>
          <Grid item xs={12} align="center" style={{backgroundColor: '#989898', color: '#fff'}}>
            <div style={{padding: 25}}>
              <Typography className={classes.textBlock1}>
                &copy; 2018 COSMOCARE. Todos los derechos reservados.
              </Typography>
              <Typography className={classes.textBlock1} component="a" href="mailto:contact@cosmocare.eu">
                Aviso Legal
              </Typography>
            </div>
          </Grid>
        </Grid>

      </div>
      </React.Fragment>
    )
  }
}

export default withStyles(styles, {withTheme: true})(HowItWorks);


// WEBPACK FOOTER //
// ./src/modules/homepage/HowItWorks.js